"use client";

import { FiltersDrawerChevronIcon } from "../lifestyleIcons";

interface DrawerRowProps {
  label: string;
  /** Selections held by this filter, badged to the left of the chevron. */
  count?: number;
  icon?: React.ReactNode;
  isActive?: boolean;
  isDisabled?: boolean;
  onClick: () => void;
}

/** A drill-down row, used by both the category list and a category's filters. */
export default function DrawerRow({
  label,
  count = 0,
  icon,
  isActive = false,
  isDisabled = false,
  onClick,
}: DrawerRowProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={isDisabled}
      className={`flex items-center w-full h-14 px-4 gap-4 text-base font-roboto leading-5.5 transition-colors hover:bg-gray-3 disabled:opacity-38 disabled:cursor-not-allowed ${
        isActive ? "font-medium text-primary" : "text-secondary"
      }`}>
      {icon}

      <span className="flex items-center justify-between flex-1 min-w-0 h-full gap-2 border-b border-black/8">
        <span className="min-w-0 truncate text-left">{label}</span>

        <span className="flex items-center shrink-0 gap-2">
          {count > 0 && (
            <span className="flex items-center justify-center min-w-5 h-5 px-1.5 text-xs font-medium text-white bg-primary rounded-full">
              {count}
            </span>
          )}
          <FiltersDrawerChevronIcon className="shrink-0 w-6 h-6 text-gray-5" />
        </span>
      </span>
    </button>
  );
}
